import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useUser, useRoles } from '../_hooks';
import Loading from '../_components/shared/loading';
import { Header } from '../_components/shared/header';


function Landing() {
    const user = useUser();
    const { canAccessRdg, canAccessRcg, isOnlyRdg, isRcgOnly } = useRoles(user);
    const hasAnyAccess = canAccessRdg || canAccessRcg;

    if (!user) return <Loading />;
    if (isRcgOnly)  return <Navigate to="/rcg/prestataire-rcg" replace />;
    if (isOnlyRdg)  return <Navigate to="/rdg" replace />;

    return (
        <>
            <Header />
            <div className={"page landing"}>
                {!hasAnyAccess ? (
                    <p className={"landing-no-access"}>
                        Votre compte n'a pas encore de rôle assigné. Contactez votre administrateur.
                    </p>
                ) : (
                    <div className={"boxes-app"}>
                        {canAccessRdg && (
                            <Link className={"box-app box-app-rdg text-center"} to={"/rdg"}>
                                <span className={"fa fa-grip-horizontal box-app-icon"}></span>
                                <h3>RDG</h3>
                            </Link>
                        )}
                        {canAccessRcg && (
                            <Link className={"box-app box-app-rcg text-center"} to={"/rcg/prestataire-rcg"}>
                                <span className={"fa fa-comment box-app-icon"}></span>
                                <h3>RCG</h3>
                            </Link>
                        )}

                    </div>
                )}
            </div>
        </>
    );
}

export { Landing };
